/* Register the PWA service worker in production. In dev (`yarn start`) it stays
 * off to keep hot reload snappy and avoid caching stale bundles. */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Skip in dev to keep CRA hot reload behaviour predictable.
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((err) => {
      console.warn("[PWA] Service worker registration failed:", err?.message || err);
    });
  });
}
